import {ProblemDetails} from '../types';

// Builds the user-facing message: the top-level title/message followed by
// each inner exception message, chained as "outer -> inner -> innermost".
function buildMessage(problemDetails: ProblemDetails): string | undefined {
    const parts: string[] = [];

    const outer = problemDetails.title ?? problemDetails.exception?.message;
    if (outer) {
        parts.push(outer);
    }

    let inner = problemDetails.exception?.innerException;
    while (inner) {
        if (inner.message) {
            parts.push(inner.message);
        }
        inner = inner.innerException;
    }

    return parts.length > 0 ? parts.join(' -> ') : undefined;
}

export default class ProblemDetailsError extends Error {
    problemDetails: ProblemDetails;

    constructor(problemDetails: ProblemDetails) {
        super(buildMessage(problemDetails));
        this.name = 'ProblemDetailsError';
        this.problemDetails = problemDetails;
    }
}
